import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;
